import { useEffect } from "react";
import { useRouter } from "next/router";
import type { AppProps } from "next/app";
import { getLocaleMeta, LOCALE_CODES, type LocaleCode } from "@/lib/i18n-config";

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();

  // _document only runs at export time, so a client-side navigation between
  // /ar/... and an LTR route would otherwise leave a stale dir on <html> and
  // the whole page would stay mirrored.
  useEffect(() => {
    const first = (router.asPath || "/").split("/").filter(Boolean)[0];
    const code = ((LOCALE_CODES as string[]).includes(first) ? first : "en") as LocaleCode;
    const meta = getLocaleMeta(code);
    document.documentElement.lang = meta.htmlLang;
    document.documentElement.dir = meta.dir;
  }, [router.asPath]);

  return <Component {...pageProps} />;
}
